import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'portfolio-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🗂 Portfolio - The Global State Manager</h1>
            <p class='section-text' tabindex='0'>
                The <b>Portfolio</b> is a built-in, global state manager for Mosaic components.
                You can think of it as being similar to Redux. The way it works is that
                components will add a reference to the portfolio object as a constructor option,
                and as a result the portfolio will add every instance of that component as a
                "dependency" of the portfolio. When it comes time to update the portfolio data,
                every dependency will be repainted so that they all reflect the current state of
                the portfolio.
            </p>
            <p class='section-text' tabindex='0'>
                The first paramter when creating a new Portfolio is an object that represents the
                global data store. It is basically the same thing as a single component's data
                property, except that this one is not Observable. Instead, it will wait until all
                of its changes are made, then update each dependency.
            </p>
            <p class='section-text' tabindex='0'>
                The second paramter is a function that, itself, takes three parameters. The first
                is the name of the event that 
            </p>

            <h1 class='section-title' tabindex='0'>
                dispatch(event: <span style='color:mediumseagreen'>string or string[]</span>,
                additionalData?: <span style='color:mediumseagreen'>Object</span>)
            </h1>
            <p class='section-text' tabindex='0'>
                To use the portfolio, we call the <b>dispatch</b> function in order to give a name
                or an array of names to the particular event that we are trying to trigger. The 
                dispatch function also allows you to send over an additional object to serve as 
                data that you want to interact with inside of the portfolio.
            </p>
            <code-segment type='JS'>
                portfolio.dispatch("say-something", { message: "Hello Mosaic!" });
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>
                get(name: <span style='color:mediumseagreen'>string</span>)
            </h1>
            <p class='section-text' tabindex='0'>
                <b>Get</b> will return to you the value of the portfolio's data property
                with the specified name, or undefined if it does not exist.
            </p>
            <code-segment type='JS'>
                const msg = portfolio.get("message");
                <br>
                console.log(msg);
            </code-segment>
            <br>

            <h1 class='section-title' tabindex='0'>Demo</h1>
            <p class='section-text' tabindex='0'>
                Below we will see how we create a portfolio object and how it can be used to
                make changes to the global state, thereby triggering repaints on any component
                that relies on it.
            </p>
            <br>
            <iframe width="100%" height="300" src="//jsfiddle.net/authman2/yfhsxrcm/62/embedded/js,html,result/" allowfullscreen="allowfullscreen" allowpaymentrequest frameborder="0"></iframe>
            
            <p class='section-text' tabindex='0' style='text-align:center;'>
                
            </p>
            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/shadowdom')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Shadow DOM
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/router')}'>
                    Mosaic Router
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});